import { storage } from '../constants';
import { getCountryCodes } from '../api/common';

const numberWithCommas = (x) => {
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const getCodes = () => {
  const currentDate = new Date();
  const storedCodes = window.localStorage.getItem(storage.COUNTRY_CODES);
  const storedTime = window.localStorage.getItem(storage.COUNTRY_CODES_TIME);
  const mapCodes = (data) => {
    const countryList = (data?.countries || []).map(country => ({
      ...country,
      value: country.id,
      label: country.name
    }));

    const USA = countryList.find(country => country.id === 'US');
    const filtered = countryList.filter(country => country.id !== 'US');
    if (USA) filtered.unshift(USA);

    const stateList = (data?.states || []).map(state => ({
      ...state,
      value: state.id,
      label: state.name
    }));

    return {
      ...data,
      countries: filtered,
      states: stateList
    };
  };

  const applyCodes = (codes) => {
    localeCodes = codes;
    countryList = codes?.countries || [];
    stateList = codes?.states || [];
    return codes;
  };

  if (storedCodes && storedTime && Number(storedTime) > currentDate.getTime()) {
    return applyCodes(mapCodes(JSON.parse(storedCodes)));
  } else {
    getCountryCodes().then(data => {
      if (!data) return;
      const codes = mapCodes(data);

      const expireDate = currentDate.setDate(currentDate.getDate() + 100);

      window.localStorage.setItem(storage.COUNTRY_CODES, JSON.stringify(codes));
      window.localStorage.setItem(storage.COUNTRY_CODES_TIME, expireDate);
      return applyCodes(codes);
    }).catch(e => console.log('error', e));

    return localeCodes;
  }
};

export let localeCodes = null;
export let countryList = [];
export let stateList = [];

getCodes();

export const getStatesOptions = (data, countryFieldName) => {
  const country = data && countryList.find(c => c.id === data[countryFieldName] || c.id === data.countryId);

  if (!country) return [];
  return stateList.filter(option => option.countryId === country.id);
};

export const getCountryName = id => {
  const country = countryList.find(c => c.id === id);
  return country ? country.name : id;
};

export const getStateName = (stateId, countryId) => {
  const state = stateList.find(s => s.id === stateId && s.countryId === countryId);
  return state ? state.name : stateId;
};

export function format(value, placeholder, type) {
  if (value !== null && value !== undefined) {
    switch (type) {
      case 'int':
        if (typeof value === 'string') value = parseFloat(value);
        value = numberWithCommas(value);
        break;

      case 'seconds':
        if (typeof value === 'string') value = parseFloat(value);
        if (value < 1) value = '< 1s';
        if (value >= 1) value = `${numberWithCommas(value.toFixed(0))}s`;
        break;

      case 'float':
        if (typeof value === 'string') value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value.toFixed(2));
        break;

      case 'price':
        value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value.toFixed(6).replace(/0{0,4}$/, ''));
        break;

      case 'millions':
        value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = value / 1000000.0;
        value = numberWithCommas(value.toFixed(2));
        break;

      case 'percentage':
        value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value.toFixed(2));
        if (value === '-0.00') value = '0.00';
        if (value.length > 0) value += '%';
        break;

      case 'tenths':
        value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value.toFixed(1));
        if (value === '-0.00') value = '0.00';
        if (value.length > 0) value += '%';
        break;

      case 'sign':
        const sign = parseFloat(value) > 0 ? '+' : '';
        value = numberWithCommas(value.toFixed(2));
        if (value.length > 0) value = sign + value;
        break;

      case 'bool':
        value = value ? 'Yes' : 'No';
        break;

      case 'text':
        break;

      case 'number':
        if (typeof value === 'string') value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value);
        break;

      case 'currency':
        if (typeof value === 'string') value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value);
        if (value.length > 0) value = '$' + value;
        break;
    }
  } else {
    value = placeholder;
  }

  return value;
}